import React from 'react';

import N8nConfigurationTab from '../../N8nConfiguration/N8nConfigurationTab';

const InternalAdminN8nWrapper: React.FC = () => {
  return React.createElement(N8nConfigurationTab, null);
};

export default InternalAdminN8nWrapper;
